import React, { useEffect } from "react";
import "./Resume.css";
import lanrePhoto from "../../images/Lanre.png";
import { FaBootstrap, FaHtml5, FaReact, FaGithub } from "react-icons/fa";
import { DiCss3, DiResponsive } from "react-icons/di";
import { IoLogoJavascript } from "react-icons/io";
import {
  SiFirebase,
  SiNextdotjs,
  SiRedux,
  SiTailwindcss,
  SiTypescript,
} from "react-icons/si";

const Resume = () => {
  // Scroll To top
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <div className="allcontent">
        <div className="profile">
          <img src={lanrePhoto} alt="" />
          <div className="text">
            <h3>Lanre Adeolu</h3>
            <p>JavaScript Developer & Coach</p>

            <div id="lasttext">
              <p></p>
            </div>
            <div className="copyright">
              <p>©2023-2024 Lanre Adeolu.</p>
            </div>
          </div>
        </div>

        <div className="resume">
          <h1 style={{ color: "#5c6e58" }}>
            RES<span style={{ color: "#ad4328" }}>UME.</span>
          </h1>
          <p>ladeolu2016@gmail.com | +234-813-6128-748 | Lagos, Nigeria</p>
          <div className="view-btn">
            <a
              href="https://docs.google.com/document/d/10UtsVBkti4DwTfCw_pEp2TU8wc7F-q3P4xlAnY_KRF0/edit?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="viewpdf"
            >
              View Document
            </a>
          </div>

          <div className="pair experience">
            <div className="left summary">
              <h2>PROFESSIONAL SUMMARY</h2>
            </div>
            <div className="right summary">
              <h6>
                A web developer and web development coach with strong
                analytical, management and communication skills, who
                continuously seeks opportunities to expand his knowledge and
                develop hard skills in a dynamic and professional environment.
              </h6>
            </div>
          </div>

          <div className="pair">
            <div className="left">
              <h2>EDUCATION</h2>
            </div>
            <div className="right">
              <h4>Tech Studio Academy</h4>
              <p>Palmgrove, Lagos state, Nigeria</p>
              <h6>Front-end Web Development</h6>
              <h4>Lagos State University </h4>
              <p>Ojo, Lagos state, Nigeria</p>
              <h6>BSc./MSc. Political Science</h6>
            </div>
          </div>

          <div className="pair experience">
            <div className="left">
              <h2>EXPERIENCE</h2>
            </div>
            <div className="right">
              <h4>
                Lead, Frontend Development <span> FastSail Technologies</span>
              </h4>
              <p>May 2024 - Present</p>
              <h6>
                Contracted to work on a series of projects involving the
                development of a scalable LMS app that would serve as a platform
                for online learning, as well as a growth acceleration app
                designed to help businesses improve efficiency and customer
                engagement. The scope included frontend development using
                ReactJS, backend development using Firebase, UI/UX design, and
                integration with existing systems.
              </h6>

              <h4>
                Frontend Lead <span> New Age Solutions/Edurex Academy</span>
              </h4>
              <p>December 2023 - April 2024</p>
              <h6>
                As the Frontend Lead at Edurex, a subsidiary of New Age
                Solutions, I played a pivotal role in leading the development of
                user-facing components for their Learning Management System
                (LMS) and cryptocurrency projects for internal and external use.
                I also led a team of frontend developers, providing technical
                guidance, code reviews, and mentorship to ensure high standards
                of code quality, best practices, and team collaboration. I
                designed and implemented frontend architecture using ReactJS and
                NextJS and also ensured a seamless integration with backend
                services and APIs hosted on Swagger. Also worked closely with
                the product designer to create user-friendly interfaces that
                aligned with the client's expectations as well as the overall
                project vision.
              </h6>

              <h4>
                JavaScript Full-stack Coach <span> Tech Accent Creatives</span>
              </h4>
              <p> August 2022 - November 2023</p>
              <h6>
                Coaching budding web developers the MERN stack (MongoDB,
                ExpressJS, ReactJS and NodeJS) with over two years worth of
                experience in full-stack web development using JavaScript
                technologies. aspiring developers. Establish a career leveraging
                technology to improve tech users’ experience especially in
                start-ups and in developing communities.
              </h6>

              <h4>
                Front-End Web Development Coach{" "}
                <span> Tech Studio Academy</span>
              </h4>
              <p> November 2021 - June 2022</p>
              <h6>
                Assist in writing well designed, testable, efficient code by
                using best software development practices. Assist in creating
                website layout/user interface by using standard HTML/CSS
                practices. Assist in integrating data from various back-end
                services and databases.
              </h6>
            </div>
          </div>

          <div className="pair">
            <div className="left">
              <h2>SKILLS</h2>
            </div>
            <div className="right">
              <div className="skills">
                <div className="skillpair">
                  <p>HTML5</p>
                  <FaHtml5
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>CSS3</p>
                  <DiCss3
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>Boostrap</p>
                  <FaBootstrap
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>JavaScript</p>
                  <IoLogoJavascript
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>NextJS</p>
                  <SiNextdotjs
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>ReactJS</p>
                  <FaReact
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>Responsive Design</p>
                  <DiResponsive
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>Git</p>
                  <FaGithub
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>TailwindCSS</p>

                  <SiTailwindcss
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>{" "}
                <div className="skillpair">
                  <p>Firebase</p>
                  <SiFirebase
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>Redux</p>
                  <SiRedux
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
                <div className="skillpair">
                  <p>TypeScript</p>
                  <SiTypescript
                    style={{
                      width: "100px",
                      fontSize: "4rem",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resume;
